
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';
//components
import MixedWidget1 from "@/components/widgets/mixed/Widget1.vue";
import StatisticsWidget5 from "@/components/widgets/statsistics/Widget5.vue";

//services
import eventService from "@/core/services/EventService";
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "acrd-home",
    components: {
        MixedWidget1, StatisticsWidget5
    },
    setup() {
        const route = useRoute();
        const { id } = route.params
        const total = ref(0)
        const listRTRegister = ref<any>([])
        const listRCheckDoc = ref<any>([])
        const listRGender = ref<any>([])
        const sports = ref(0)
        const clubs = ref(0)

        const getSummary = async () => {
            total.value = 0
            sports.value = 0
            clubs.value = 0
            listRTRegister.value.slice(0)
            listRCheckDoc.value.slice(0)
            listRGender.value.slice(0)
            await eventService.summary({
                idevent: id, })
            .then( (res) => {
                sports.value = res.data.sports
                clubs.value = res.data.clubs
                listRTRegister.value = res.data.rtregister
                listRCheckDoc.value = res.data.rcheckdoc
                listRGender.value = res.data.rgender
                listRGender.value.forEach(element => {
                    total.value += parseInt(element.quantity)
                });
            }).catch ( ({ response }) => {
                errManager(response)
            })
        }

        onMounted(()=>{
            getSummary()
        })

        return {
            id,
            total,
            sports,
            clubs,
            listRTRegister,
            listRCheckDoc,
            listRGender,
            //events
            getSummary
        }
        
    },
})
